import React, { Component } from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { CarouselContainer } from "./style";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

class FixedTextImageCarousel extends Component {
	render() {
		const settings = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: true,
			speed: 500,
		};

		return (
			<div>
				<Helmet>
					<link
						rel="stylesheet"
						type="text/css"
						charset="UTF-8"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
					/>
					<link
						rel="stylesheet"
						type="text/css"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
					/>
				</Helmet>
				<CarouselContainer>
					<div className="imageContainer">
						<Slider {...settings}>
							{this.props.images.map((image, index) => {
								return (
									<div key={index}>
										<img className="image" src={image.imageUrl} />
									</div>
								);
							})}
						</Slider>
					</div>
					<div className="content">
						<div className="heading">{this.props.heading}</div>
						<div
							className="description"
							dangerouslySetInnerHTML={{ __html: this.props.description }}
						></div>
					</div>
					<div className="tabViewContainer">
						{this.props.images.map((image, index) => {
							return (
								<div key={index}>
									<CloudinaryImage
										url={image.imageUrl}
										lazyload
										className="tabImage"
									/>
								</div>
							);
						})}
					</div>
				</CarouselContainer>
			</div>
		);
	}
}

FixedTextImageCarousel.propTypes = {
	heading: Proptypes.string,
	description: Proptypes.string,
	images: Proptypes.array,
};

FixedTextImageCarousel.defaultProps = {
	heading: "",
	description: "",
	images: [],
};

export default FixedTextImageCarousel;
